<template>
  <category-page
    :resource-params="resourceParams"
    :available-filters="availableFilters"
    :parent="parent"
  />
</template>

<script>
/* List resources by file format
 *
 * @parent:
 * @requests: /public/v1/category
 * @events:
 * @props:
 * @components: CategoryPage
 * @methods:
 */

import CategoryPage from '~/components/category/CategoryPage.vue';

const root = 'file-format';

export default {
  name: 'FileFormat',
  components: {
    CategoryPage,
  },
  async asyncData({ store, route, params, error }) {
    const data = {};
    const loggedInUser = store.getters.loggedInUser;

    // For the resource list query
    data.resourceParams = {
      category: params.slug,
      perPage: 32,
      root,
    };

    // Auto-select user's year level(s) when making a query
    if (loggedInUser && loggedInUser.year_levels) {
      data.resourceParams.year_levels = loggedInUser.year_levels;
    }

    try {
      // Load the category title, description and list of sub-categories
      const category = await store.dispatch('loadCategory', {
        category: params.slug,
        root,
        link: route.path,
      });

      // For meta fields
      data.title = category.name + ' Teaching Resources';
      data.category = category;
      data.link = category.link;
    } catch (err) {
      // No page matching this route
      error({ statusCode: 404, message: err.message, path: route.path });
    }

    return data;
  },
  data() {
    return {
      title: 'Teaching Resources by file format',
      category: {},
      parent: { link: '/' + this.$i18n.locale + '/file-formats/', name: 'File Formats' },
      resourceParams: {},
      availableFilters: [
        'types',
        'learning_areas',
        'year_levels',
        'resource_types',
        'availability',
        'publishers',
      ],
    };
  },
  jsonld() {
    return this.$jsonSchemaPage(this.title, this.$route.path);
  },
  head() {
    return {
      title: this.title,
      meta: this.$metaPropertiesCategory(this.category),
      link: this.$hrefLangsPage(this.$route),
    };
  },
};
</script>
